import styled from "styled-components";

import { PrivacyStyledProps as Props } from "./Privacy.types";
import CONSTANTS from "config/constants";

const { BREAKPOINTS } = CONSTANTS;
const { desktop, tablet, mobile } = BREAKPOINTS;

const PrivacyStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: calc(var(--sizes-navbar-height) - env(safe-area-inset-top));
  background-color: var(--palette-black-s0-l10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (max-width: ${desktop}px) {
    padding-top: var(--sizes-navbar-height-mobile);
  }

  @media (max-width: ${tablet}px) {
    padding-top: calc(
      var(--sizes-navbar-height-mobile) - env(safe-area-inset-top)
    );
  }

  .Privacy {
    &__header {
      grid-area: header;
    }

    &__main {
      grid-area: main;
      margin-bottom: 3.2rem;
      padding-top: 8.8rem;

      @media screen and (min-width: ${desktop}px) {
        display: grid;
        grid-template-columns: 44rem 1fr;
        grid-template-rows: min-content max-content;
        grid-template-areas: "profile-navigation content";
      }

      @media (max-width: ${tablet}px) {
        padding-top: 4rem;
      }
    }

    &__profile-navigation {
      display: none;

      @media screen and (min-width: ${desktop}px) {
        display: flex;
        grid-area: profile-navigation;
        margin-left: 4rem;
      }
    }

    &__content {
      grid-area: content;
      flex: 1;
      padding: 0 8rem;

      @media (max-width: ${desktop}px) {
        padding: 0 4rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }

      .Clickable {
        padding-left: 0;
        padding-top: 0;
      }
    }

    &__container {
      background-color: var(--palette-black-s2-l17);
      padding: 2.4rem;
      border-radius: 1.6rem;
    }

    &__title {
      margin-bottom: 2.4rem;
      font-size: 2.4rem;
      color: var(--palette-gray-s0-l80);
      font-weight: 700;
    }

    &__subtitle {
      margin-top: 3.2rem;
      margin-bottom: 0.8rem;
      font-size: 2rem;
      color: var(--palette-gray-s0-l80);
      font-weight: 700;
    }

    &__paragraph {
      font-size: 1.6rem;
      color: var(--palette-gray-s0-l80);
      text-align: justify;
      line-height: 2.4rem;

      &:not(:last-child) {
        padding-bottom: 2.4rem;
      }
    }

    &__list-items {
      padding-left: 1.6rem;
    }

    &__footer {
      grid-area: footer;
      padding-top: 3.2rem;
    }
  }
`;

export default PrivacyStyled;
